import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { omitRestEmpty } from '@1c/utils/lib/restApi';
import { useNavigate } from 'src/utils/useNavigate';
import routes from 'src/constants/routes';
import useAccountProfile from 'src/dataHooks/useAccountProfile';
import PageSpin from 'src/components/PageSpin';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import Form from './Form';
import styles from './styles.module.scss';

const AccountProfile: React.FC = () => {
  const navigate = useNavigate();

  const {
    wasAccountProfileFetched,
    accountProfileError,
    fetchAccountProfile,
    accountProfile,
  } = useAccountProfile();

  useEffect(() => {
    fetchAccountProfile();
  }, [fetchAccountProfile]);

  useEffect(() => {
    if (accountProfileError) {
      toast.error('Произошла ошибка загрузки данных пользователя');
      navigate(routes.agent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountProfileError]);

  if (!wasAccountProfileFetched) {
    return <PageSpin />;
  }

  return (
    <ContentLayout size="small">
      <Text type="h2" className={styles['title']}>Профиль</Text>
      <Form accountProfile={omitRestEmpty(accountProfile)} />
    </ContentLayout>
  );
};

export default AccountProfile;
